<template>
  <div class="prices" :class="this.$isPC ? '' : 'sp-prices'">
    <div v-if="items.length > 0">
      <!-- <opening-campaign-price /> -->
      <form-campaign-price />
      <div class="price-list">
        <price v-for="(item, index) in items" :key="index" v-bind:item="item" />
      </div>
    </div>
    <div v-else>ただいま商品を準備中です。</div>
  </div>
</template>

<script>
import OpeningCampaignPrice from '@/components/modules/campaign/OpeningCampaignPrice'
import FormCampaignPrice from '@/components/modules/campaign/FormCampaignPrice'
import Price from '@/components/modules/products/Price'

export default {
  props: ['items'],
  components: {
    OpeningCampaignPrice,
    FormCampaignPrice,
    Price,
  },
}
</script>

<style scoped>
.prices {
  width: 90%;
  max-width: 1100px;
  margin: 0 auto;
}

.campaign-price {
  width: 100%;
  margin: 0 auto;
}

.price-list {
  display: flex;
  flex-wrap: wrap;
}

.sp-prices .price-list {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Prices.vue